import type CoacheeService from '@efdigital/ll-xceed-v2/services/coachee';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class CoachingCoacheeIndexRoute extends Route {
  @service declare router: RouterService;
  @service declare coachee: CoacheeService;

  async afterModel() {
    const cohorts = await this.coachee.cohortsWithCoaching();
    if (cohorts.length > 0) {
      const cohort = cohorts[0]!;
      this.router.transitionTo(
        'coaching.coachee.cohort.index',
        cohort.program.id,
        cohort.id
      );
    }
  }
}
